module.exports = __webpack_public_path__ + "img/kp8hover.83903148.png";